import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ExtendedRentalViewModel } from '@app/models';
import ExtendedRental from '@app/models/extended-rental';
import ExtendedRentalStandardDiscountRequest from '@app/models/extended-rental-standard-discount-request';

/**
 * Extended Rental/Lease Discount Service
 */
@Injectable()
export class ExtendedLeaseDiscountService {
  private readonly _serviceName = 'ExtendedLeaseDiscountService';

  constructor(readonly http: HttpClient) {}

  /**
   * Get Extended Lease Discounts for a Listing ID
   * @param listingId
   */
  getExtendedLeaseDiscounts(listingId: number) {
    // console.log(`${this._serviceName}.getExtendedLeaseDiscounts(listingId:number) listingId=${listingId}`);

    return this.http.get<ExtendedRentalViewModel[]>(`ExtendedRental/${listingId}`);
  }

  /**
   * Adds a standard set of discounts to a listing
   */
  addStandardDiscounts(listingId: number, type: string) {
    const data = { listingId: listingId, standardDiscountType: type } as ExtendedRentalStandardDiscountRequest;

    return this.http.post<ExtendedRentalViewModel[]>('admin/ExtendedRental/AddStandardDiscounts', data);
  }

  removeAllDiscounts(listingId: number) {
    return this.http.delete(`admin/ExtendedRental/${listingId}/all`);
  }

  removeDiscount(extendedRentalId: number) {
    return this.http.delete(`admin/ExtendedRental/${extendedRentalId}`);
  }

  removeDiscounts(extendedRentalIds: number[]) {
    const ids = extendedRentalIds.map(e => `extendedRentalId=${e}`).join('&');

    return this.http.delete(`admin/ExtendedRental/array/?${ids}`);
  }

  addExtendedRentalDiscount(extendedRental: ExtendedRental) {
    return this.http.post('admin/ExtendedRental', extendedRental);
  }

  /**
   * Updates and existing Extended Rental/Lease Discount
   * @param extendedRental
   */
  updateDiscount(extendedRental: ExtendedRental) {
    return this.http.put('admin/ExtendedRental', extendedRental);
  }
}
